import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { Spinner } from "@/components/General/Spinner/spinner.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { TextField } from "../../../FormFields/TextField/Textfield.component";
import { useAddressFormBlockContext } from "../addressFormBlock.context";
import { CustomerPaymentAddressFormValues } from "../addressFormBlock.schema";
import { usePaymentHook } from "../helpers/usePayment.hook";
import { PaymentAddressPartial } from "../partials/paymentAddress";

const PaymentCustomerAddress = () => {
    const { t } = useGranite();
    const { loading } = usePaymentHook();

    const { addPrefix } = useAddressFormBlockContext();

    if (loading) {
        return <Spinner />;
    }

    return (
        <>
            <Row>
                <Col md={6}>
                    <TextField<CustomerPaymentAddressFormValues>
                        test={`customerAddress-input-${addPrefix("firstName")}`}
                        name={"payment.firstName"}
                        label={t("general.form.address.firstName.label")}
                        required
                        placeholder={t(
                            "general.form.address.firstname.placeholder"
                        )}
                        autoComplete={"given-name"}
                    />
                </Col>
                <Col md={6}>
                    <TextField<CustomerPaymentAddressFormValues>
                        test={`customerAddress-input-${addPrefix("lastName")}`}
                        name={"payment.lastName"}
                        label={t("general.form.address.lastName.label")}
                        required
                        placeholder={t(
                            "general.form.address.lastName.placeholder"
                        )}
                        autoComplete={"family-name"}
                    />
                </Col>
            </Row>
            <PaymentAddressPartial />
        </>
    );
};

export { PaymentCustomerAddress };
